
















import { Component, Vue } from "vue-property-decorator";
import FileManager from "@/components/files/FileManager.vue";
import { FolderEntites } from "@/services/folders/types";
import { MediaType } from "@/services/files/types";

@Component({
    components: {
        "file-manager": FileManager
    }
})
export default class Files extends Vue {
    folderEntities = FolderEntites;
    types = [];
}
